import { render, staticRenderFns } from "./viewProposals.vue?vue&type=template&id=265e355b&scoped=true&"
import script from "./viewProposals.vue?vue&type=script&lang=js&"
export * from "./viewProposals.vue?vue&type=script&lang=js&"
import style0 from "./viewProposals.vue?vue&type=style&index=0&lang=css&"
import style1 from "./viewProposals.vue?vue&type=style&index=1&id=265e355b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265e355b",
  null
  
)

export default component.exports